import { axiosInstance } from '../core';
import { GetLanguagesDTO } from './dto/languages.dto';

export async function getLanguages(): Promise<GetLanguagesDTO> {
  return (await axiosInstance.get('/languages/all')).data;
}
